const midYOfFret = (
  fretYPositions: number[],
  fretDistance: number,
) => (fret: number) => (fretYPositions[fret] ?? 0) + fretDistance / 2

export { midYOfFret }
